'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('resident-directory', {
      url: '/resident/directory',
      template: '<resident-directory></resident-directory>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/resident/resident-directory.routes.js